import { css, styled } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledRadioOptionContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacing('LARGE')};
    cursor: pointer;
    word-break: break-word;
  `
);
